import { render, staticRenderFns } from "./ProfileRating.vue?vue&type=template&id=437228cb&"
import script from "./ProfileRating.vue?vue&type=script&lang=js&"
export * from "./ProfileRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports